import { render, staticRenderFns } from "./HotelPlanner.vue?vue&type=template&id=fa4ba992&"
import script from "./HotelPlanner.vue?vue&type=script&lang=js&"
export * from "./HotelPlanner.vue?vue&type=script&lang=js&"
import style0 from "./HotelPlanner.vue?vue&type=style&index=0&id=fa4ba992&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa4ba992')) {
      api.createRecord('fa4ba992', component.options)
    } else {
      api.reload('fa4ba992', component.options)
    }
    module.hot.accept("./HotelPlanner.vue?vue&type=template&id=fa4ba992&", function () {
      api.rerender('fa4ba992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/HotelPlanner/HotelPlanner.vue"
export default component.exports